import { render, staticRenderFns } from "./ItemsCarousel.vue?vue&type=template&id=1093345e&scoped=true&"
import script from "./ItemsCarousel.vue?vue&type=script&lang=js&"
export * from "./ItemsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ItemsCarousel.vue?vue&type=style&index=0&id=1093345e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1093345e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
